import { Clock } from "lucide-react";

export default function ComingSoonBadge({ className = "", label = "Coming soon", testid }) {
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center gap-1 rounded-full border border-black/10 bg-white/80 px-2 py-0.5 text-[10px] uppercase tracking-[0.18em] text-neutral-500 ${className}`}
    >
      <Clock className="h-3 w-3" />
      {label}
    </span>
  );
}
